import { User } from 'src/types';

import type { Request } from '@atlassian/tesseract-runtime-globals';

export const registerUserInNitro = async (user: User): Promise<boolean> => {
  const typedGlobalThis = globalThis as typeof globalThis & { __COOKIES__: Request['headers']['cookie'] };

  const headers = {
    'Content-Type': 'application/json',
    Origin: globalThis.location.origin,
    ...(typedGlobalThis.__COOKIES__ ? { cookie: typedGlobalThis.__COOKIES__ } : {}),
  };

  try {
    const response = await fetch(`${globalThis.location.origin}/gateway/api/learning-app/kms/user`, {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify({
        id: user.account_id,
        name: user.name,
        email: user.email,
        picture: user.picture,
      }),
    });

    return response.ok;
  } catch (error) {
    return false;
  }
};
